import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Slider from "react-slick";
import './secciones.css'

const Aplicaciones = ({ aplicaciones }) => {

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3500,
        pauseOnHover: true,
        responsive: [
            {
                breakpoint: 1360,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1
                }
            }
        ]
    };

    let colLenght = 10;

    if (!aplicaciones || aplicaciones.length < 1) {
        return null;
    } else {
        if (aplicaciones.length < 4) {
            settings.slidesToShow = aplicaciones.length;
            colLenght = aplicaciones.length * 3;
        }
    }
    return (
        <Row>
            <Col xs={11} md={colLenght} className="mx-auto px-4 my-ficha">
                <Slider {...settings} className="slider-multiple">
                    {aplicaciones && aplicaciones.length > 0 &&
                        aplicaciones.map((aplicacion, i) =>
                            <Row key={i} className=" border-right-apl mx-auto mb-5">
                                <Col xs={11} className="mx-auto text-center">
                                    <img src={aplicacion.Imagen} alt={aplicacion.Nombre} className="img-fluid img-aplicacion mx-auto" />
                                    <p className="bold-title-hyundai f-responsive mt-4">{aplicacion.Nombre}</p>
                                </Col>
                            </Row>
                        )}
                </Slider>
            </Col>
        </Row>


    );
}

export default Aplicaciones;